import _extends from "@babel/runtime/helpers/extends";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';

var _ref =
/*#__PURE__*/
___EmotionJSX("ellipse", {
  cx: 39,
  cy: 66,
  rx: 26,
  ry: 5,
  fill: "#C1E5FF"
});

var _ref2 =
/*#__PURE__*/
___EmotionJSX("path", {
  d: "M25.944 13.843a4 4 0 0 1 2.812-1.21l19.263-.26a4 4 0 0 1 2.844 1.133l13.805 13.436a4 4 0 0 1 1.21 2.813l.26 19.262a4 4 0 0 1-1.133 2.844L51.57 65.668a4 4 0 0 1-2.813 1.21l-19.263.26a4 4 0 0 1-2.844-1.133L12.844 52.567a4 4 0 0 1-1.21-2.812l-.26-19.263a4 4 0 0 1 1.133-2.844l13.437-13.805z",
  fill: "#73C4FF"
});

var _ref3 =
/*#__PURE__*/
___EmotionJSX("rect", {
  x: 48.152,
  y: 28.945,
  width: 3,
  height: 30,
  rx: 1.5,
  transform: "rotate(45 48.152 28.945)",
  fill: "#fff"
});

var _ref4 =
/*#__PURE__*/
___EmotionJSX("rect", {
  x: 50.273,
  y: 49.449,
  width: 3,
  height: 30,
  rx: 1.5,
  transform: "rotate(135 50.273 49.45)",
  fill: "#fff"
});

var SvgComponent = function SvgComponent(props) {
  return ___EmotionJSX("svg", _extends({
    width: 78,
    height: 79,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/faq-risky-activity.a8c51be4.svg";
export { SvgComponent as ReactComponent };